export default {
  cpf: '###.###.###-##',
  cnpj: '##.###.###/####-##'
}



// WEBPACK FOOTER //
// ./src/translate/pt_br/mask.js